import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"elevation-0 text-center pt-5"},[_c(VRow,{staticStyle:{"margin":"0"}},[_c('div',{staticClass:"full-width headline mb-3"},[_vm._t("heading")],2),_vm._v(" "),_c(VBtn,{staticClass:"dialog-close-btn",attrs:{"text":"","icon":""},on:{"click":_vm.close}},[_c(VIcon,[_vm._v("$vuetify.icons.close")])],1)],1),_vm._v(" "),_c('span',[_vm._t("content")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }